import rodzajFelgi from '@components/search/inputs/rodzajFelgi'
import srednica from '@components/search/inputs/srednica'

const felgi = {
    type: 'conditional',
    name: 'felgi',
    conditions: { 'rodzaj-czesci': 'Felgi' },
    inputs: [
        rodzajFelgi,
        srednica,
    ],
}

export default felgi